import { render } from "./FlashCard.vue?vue&type=template&id=0761c2e1&scoped=true"
import script from "./FlashCard.vue?vue&type=script&lang=js"
export * from "./FlashCard.vue?vue&type=script&lang=js"

import "./FlashCard.vue?vue&type=style&index=0&id=0761c2e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0761c2e1"]])

export default __exports__